import { render, staticRenderFns } from "./Puertas.vue?vue&type=template&id=3989e194&scoped=true"
import script from "./Puertas.vue?vue&type=script&lang=js"
export * from "./Puertas.vue?vue&type=script&lang=js"
import style0 from "./Puertas.vue?vue&type=style&index=0&id=3989e194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3989e194",
  null
  
)

export default component.exports